module.exports = __webpack_public_path__ + "static/media/calendar-line.e5627ed0.svg";